// @flow

import registrationNumbers from './registration-numbers'

export default registrationNumbers
